/**
 * yuriCargo連携設定ページ用のスクリプト
 */
if (is_route('yuricargo_vehicles_config.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        yuricargo_vehicles_config_event_set();
    });
}

/**
 * ページ読み込み時のイベント設定
 */
window.yuricargo_vehicles_config_event_set = function()
{
    // 設定保存時
    $(document).on('click', '.use_yuricargo_flag_btn', function (e) {
        const action = $(this).data('action');
        const data = {'holding_id': $(this).data('holding_id'), 'vehicle_ids':[$(this).data('vehicle_id')], 'use_yuricargo_flag': $(this).val()};
        _ajax.post(action, data, function (results) {
            toastr.success(results.messages);
            $('#main-area-usage-count').html(results.usage_count);
            $('#main-area-limit-count').html(results.limit_count);
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
            load_contents();
        });
    });

    // 一括のチェックボックスクリック時
    $(document).on('click', '#yuricargo_vehicles-all-select', function () {
        $(".yuricargo_vehicles-select").prop('checked', $(this).prop('checked'));
    });

    // 一括・一覧のチェックボックス変更時
    $(document).on('change', '#yuricargo_vehicles-all-select, .yuricargo_vehicles-select', function () {
        const flag = $('.yuricargo_vehicles-select[name="vehicle_id"]:checked').length == 0 || $('#search-form-company_id').val() == '';
        // 一覧のチェック状態を判定し一括設定ボタンを有効化
        $('[data-bulk-setting-modal]').prop('disabled', flag);
    });

    // 「一括設定」ボタンクリック時
    $(document).on('click', '[data-bulk-setting-modal]', function () {
        const ids = [];
        $('.yuricargo_vehicles-select[name="vehicle_id"]:checked').each(function() {
            ids.push($(this).val());
        });
        // idsは件数が大量にある場合に配列のままだとエラーが出る場合があるため文字列に変換
        _modal.create_with_data(this, 'bulk-setting-modal', {'holding_id':$(this).data('holding_id'), 'company_id': $('#search-form-company_id').val(), 'vehicle_ids': ids.join(",")});
    });

    // 一括設定の適用ボタンクリック時
    $(document).on('click', '[data-bulk-change-modal]', function () {
        _modal.submit(this, 'bulk-change-modal');
    });

    /*---- CSVダウンロード時 ----*/
    
    // CSVダウンロード時
    $(document).on('click', '#search-form-action_download', function () {
        // アクションの取得
        let action = extend_url_query($(this).data('action'));
        // 検索フォームを配列化
        let datas = $('#search-form').serializeArray();
        // ポスト送信を実行
        post(action, datas);
    });

    // 会社変更時
    $(document).on('change', '#search-form-company_id', function () {
        let action = $('#search-form').attr('action').replace('/list', '');
        const params = new URLSearchParams(location.search);
        let newParams = new URLSearchParams();
        if (params.has('holding_id')) {
            newParams.append('holding_id', params.get('holding_id'));
        }
        if($(this).val() != ''){
            newParams.append('company_id', $(this).val());
        }
        action = newParams.toString() ? (action + '?' + newParams.toString()) : action;
        location.href = action;
        return false;
    });

    // 営業所変更時
    $(document).on('change', '#search-form-section_id', function () {
        let action = $('#search-form').attr('action').replace('/list', '');
        const params = new URLSearchParams(location.search);
        let newParams = new URLSearchParams();
        if (params.has('holding_id')) {
            newParams.append('holding_id', params.get('holding_id'));
        }
        if (params.has('company_id')) {
            newParams.append('company_id', params.get('company_id'));
        }
        if($(this).val() != ''){
            newParams.append('section_id', $(this).val());
        }
        action = newParams.toString() ? (action + '?' + newParams.toString()) : action;
        location.href = action;
        return false;
    });

}
